export const WriteRight = "WEB_MODULE_PILOT_COASTAL_SEGMENTS_LOCATIONS_WRITE";
export const Rights = [
    WriteRight
]
